import { render, staticRenderFns } from "./PDFPaginator.vue?vue&type=template&id=ee610662"
import script from "./PDFPaginator.vue?vue&type=script&lang=js"
export * from "./PDFPaginator.vue?vue&type=script&lang=js"
import style0 from "./PDFPaginator.vue?vue&type=style&index=0&id=ee610662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports